<script lang="ts">
  import NotificationsTable from "@kontextwerk/control-web-frame/shared/modules/notifications-table"
  import type {
      NotificationActionHelpers,
      NotificationRow,
  } from "@kontextwerk/control-web-frame/shared/logic/notifications"
  import { userDisplayName } from "@kontextwerk/control-web-frame/shared/logic/user-presentation"
  import TodoActionButtons from "./_actions/TodoActionButtons.actions"
  import { getAdminApi } from "../../../../../../api/kehrblatt/client"
  import type { Notification, OrganizationFrame } from "@kontextwerk/control-web-client"
  import type { OrgaViewFrameContext } from "../../../../context"
  import type { PageContext } from "../../navigation"
  import {
    KEHRBLATT_INBOX_NOTIFICATION_TYPES,
    KEHRBLATT_INBOX_TODO_TYPE_FILTERS,
  } from "./_logic/notificationFilterRegistry"
  import { KEHRBLATT_INBOX_BATCH_ACTION_CATALOG } from "./_logic/inboxBatchActions"
  import { filterActiveOrganizationUsers } from "../../../../_shared/_logic/organization-users"

  const { viewFrameContext: _viewFrameContext, pageContext } = $props<{
    viewFrameContext: OrgaViewFrameContext
    pageContext: PageContext
  }>()

  const organization = $derived(pageContext.organization)
  const onNotificationsChanged = $derived(pageContext.onNotificationsChanged)
  const includeAllUsers = $derived(
    pageContext.permissions.allows("core.notifications", "view", { scope: "all" }),
  )
  const todoAssignees = $derived(
    includeAllUsers
      ? filterActiveOrganizationUsers<OrganizationFrame["users"][number]>(organization?.users ?? []).map((user) => ({
          name: userDisplayName(user) || "Unbekannt",
          value: user.id,
        }))
      : [],
  )
</script>

{#if organization}
  <NotificationsTable
    fetchNotifications={(params) =>
      getAdminApi().notifications.listForOrg(organization.id, {
        includeAllUsers,
        ...params,
      })}
    header={{
      title: "Mitteilungen",
      helpModalTextId: "kehrblattInbox",
    }}
    context={{
      notificationTypes: KEHRBLATT_INBOX_NOTIFICATION_TYPES,
      organizationId: organization.id,
      includeAllUsers,
    }}
    filters={{
      searchMode: "fulltext",
      searchPlaceholder: "Suche in Mitteilung oder Beschreibung",
      typeFilterPlacement: "detailed",
      defaultStatus: "OPEN",
      statusPlacement: "primary",
      enableModeToggle: true,
      initialMode: "compact",
      assigneeOptions: todoAssignees,
      eventTypeOptions: KEHRBLATT_INBOX_TODO_TYPE_FILTERS,
      eventTypePlaceholder: "To-Do-Typ",
      eventTypeFilterField: "flowKey",
      eventTypePlacement: "detailed",
    }}
    actions={{
      allowMarkDone: true,
      batchActionCatalog: KEHRBLATT_INBOX_BATCH_ACTION_CATALOG,
      onChanged: onNotificationsChanged,
      rowActions: ({ notification, row, helpers }) =>
        TodoActionButtons({
          todo: notification,
          row,
          helpers,
          organization,
          trialRestrictionsActive: _viewFrameContext.trialRestrictionsActive,
        }),
    }}
    manualEntries={{
      enabled: true,
      assignees: todoAssignees,
    }}
    inlineEdit={{
      assignees: todoAssignees,
    }}
  />
{/if}
